import { ALERT_SEARCH_PARAMS_SCHEMA } from '@repo/ccc-case-app-lib/src/constants/alertSearchParamsSchema.ts'
import { AlertsPage } from '@repo/ccc-case-app-lib/src/pages/AlertsPage.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/alerts')({
  validateSearch: ALERT_SEARCH_PARAMS_SCHEMA,
  component: CaseAlertsPageContainer,
})

function CaseAlertsPageContainer() {
  return <AlertsPage />
}
